/**
 * Checkbox input component with controlled checked state and
 * onCheckedChange callback for boolean toggle interactions.
 */
import * as React from "react"

import { cn } from "@/lib/utils"

export interface CheckboxProps extends Omit<React.ComponentProps<"input">, "type" | "onCheckedChange"> {
	onCheckedChange?: (checked: boolean) => void
}

/**
 * Checkbox component with support for onCheckedChange callback
 */
const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
	({ className, onCheckedChange, onChange, ...props }, ref) => {
		/**
		 * Handles checkbox change events
		 * @param e - the change event
		 */
		const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
			onChange?.(e)
			onCheckedChange?.(e.target.checked)
		}

		return (
			<input
				type="checkbox"
				className={cn(
					"h-4 w-4 shrink-0 rounded-sm border border-input ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 accent-primary",
					className
				)}
				ref={ref}
				onChange={handleChange}
				{...props}
			/>
		)
	}
)
Checkbox.displayName = "Checkbox"

export { Checkbox }
